import { type NewPartyDTO } from "#src/constants/party.ts";
import { Delete, Post, Put } from "#src/HttpClient.ts";
import { type RawEft } from "#src/types/Eft.ts";
import { type Pinia } from "pinia";

const controller = "/strife/v1/entities";

export async function createEntity(pinia: Pinia, body: NewPartyDTO) {
  const { data } = await Post(pinia, {
    url: controller,
    includeEappData: true,
    body: {
      entity: {
        irrevocable: body.irrevocable,
        application_roles_attributes: body.application_roles_attributes,
        addresses_attributes: body.addresses_attributes,
      },
    },
  });
  return data.entity;
}

export async function updateEntity(pinia: Pinia, id: number, entity: any) {
  const { data } = await Put(pinia, {
    url: `${controller}/${id}`,
    includeEappData: true,
    body: { entity },
  });
  return data?.entity;
}

export async function deleteEntity(pinia: Pinia, id: number) {
  return Delete(pinia, { url: `${controller}/${id}`, includeEappData: true });
}

export async function updateEft(
  pinia: Pinia,
  id: number,
  args: {
    routing_number: string;
    account_number: string;
    draft_day_of_month: string;
  }
): Promise<RawEft> {
  const { data } = await Put(pinia, {
    url: `${controller}/${id}/eft`,
    includeEappData: true,
    body: {
      routing_number: args.routing_number,
      account_number: args.account_number,
      draft_day_of_month: args.draft_day_of_month,
    },
  });
  return data;
}
